import { useBoardPermissions } from '~/hooks/useBoardPermissions';
import { useFetchAnyWorkspacePermissions } from '~/hooks/useFetchAnyWorkspacePermissions';
import { useURLBoardIdSelector } from '~/hooks/useURLBoardIdSelector';
import { useCanViewPrivateAddOn } from '~/swr-hooks/workspaces/addOns/useCanViewPrivateAddOn';
import { canViewInsightsMetrics } from '~/utils/permissions/assetPermissions';
import { canViewBoardMetrics } from '~/utils/permissions/boardPermissions';
import { canViewAddOns } from '~/utils/permissions/workspacePermissions';

export const useCanViewPrivateMetrics = () => {
  const boardId = useURLBoardIdSelector();
  const { boardPermissions } = useBoardPermissions({ boardId });
  const { data: workspacePermissions, isFetched: hasFetchedWorkspacePermissions } = useFetchAnyWorkspacePermissions();
  const { canViewAddOn, isLoading: isAddOnLoading } = useCanViewPrivateAddOn({ key: 'internalAnalytics' });
  const canViewMetricsForScope = boardId
    ? canViewBoardMetrics(boardPermissions)
    : canViewInsightsMetrics(workspacePermissions);

  return {
    canViewMetrics: canViewAddOn && canViewMetricsForScope,
    hasResolvedMetricsAccess:
      hasFetchedWorkspacePermissions &&
      (!boardId || boardPermissions !== undefined) &&
      !(canViewAddOns(workspacePermissions) && isAddOnLoading),
  };
};
